import http from '../../axios-config/g-http-metodos';

function getEmpresasByClienteId(clienteId) {
    const { res, erro, requisicao } = http.get(`Cliente/GetUnidadeByClienteId/${clienteId}`)
    return { EmpresaArray: res, erro, requisicao }
}

function getAllEmpresa() {
    const { res, erro, requisicao } = http.get(`Empresa/get`)
    return { EmpresaArray: res, erro, requisicao }
}

function getEmpresasAtivas(){
    const { res, erro, requisicao } = http.getArray(`Empresa/get`)
    return { EmpresaArray: res, erro, requisicao }
}

function getEmpresaByOrcamentoId(orcamentoId) {
    const { res, erro, requisicao } = http.get(`Empresa/getByOrcamento/${orcamentoId}`)
    return { EmpresaArray: res, erro, requisicao }
}



const EmpresaController = {
    getEmpresasByClienteId,
    getEmpresasAtivas,
    getAllEmpresa,
    getEmpresaByOrcamentoId
}

export default EmpresaController
